import React from "react";
import { CircularProgress } from "@material-ui/core";

import { LoaderMessage } from "../../../loader-message/loader-message.component";

import { SpinnerContentProps } from "./spinner-content.props";

export const SpinnerContent = (props: SpinnerContentProps) => {
  return (
    <>
      <LoaderMessage message={props.message!} showIf={!!props.message} />
      <CircularProgress color={props.color} size={props.size} />
    </>
  );
};
